'use strict';
import { tns } from "tiny-slider/src/tiny-slider"

class ImageGridWithCaption {

	constructor($target) {

		//Private properties
		$target;

		let name = "HELLO";

		function init(){
			initSLider()
		}

		function initSLider(){
			var slider = tns({
				container: $target.find('.block_image_grid_with_caption__content_container')[0],
				items: 2,
				slideBy: 'page',
				autoplay: false,
				controls:false,
				nav: true,
				navPosition: "bottom",
				loop: false,
				edgePadding: 20,
				gutter: 20,
				responsive: {
					768: {
					  items: 4,
					},
					992: {
						items: 6,
					}
				}
			  });
		}

		init()
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				// console.log(name)
				// console.log(string)
				// console.log($target)

			}

		}

	}

}

export default ImageGridWithCaption;